import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class UploadService {

    constructor(
        private commonService: CommonService,
        private http: HttpClient
    ) { }

    public doUpload(url: string,formData: FormData) {
        const options = {
            reportProgress: true,
        };

        return this.http.post(url, formData, options);
    }
}
